<template>
  <div class="base-layout">
    <!-- 头部导航 -->
    <sev-head v-if="hasHead" />
    <div class="base-content">
      <router-view v-if="unSlideFade" />
      <transition name="slide-fade" mode="out-in" v-else>
        <router-view />
      </transition>
    </div>
  </div>
</template>

<script>
import SevHead from './components/sevHead'
import { listReceiverInfo } from '_api/sev'

export default {
  components: {
    SevHead
  },
  // 公共meta
  metaInfo() {
    return {
      // 默认title
      title: this.$route.meta.title ? `${this.$route.meta.title}` : '售后服务'
    }
  },
  created() {
    this.setHeight()
    window.addEventListener('resize', this.setHeight)
    this.$toast.loading = msg => {
      return this.$toast({
        message: msg || '加载中',
        forbidClick: true,
        duration: 0,
        className: 'sev-loading',
        icon: 'circle'
      })
    }
    this.$toast.success = (msg, onClose) => {
      return this.$toast({
        message: msg,
        forbidClick: true,
        icon: require('img/sev/icon/passed.png'),
        onClose: onClose
      })
    }
    this.$toast.fail = (msg, onClose) => {
      return this.$toast({
        message: msg,
        forbidClick: true,
        icon: require('img/sev/icon/close.png'),
        onClose: onClose
      })
    }
    // 只有从APP,服务号,小程序,商城H5 进入需要请求地址数据
    if ([1, 2, 3, 4].includes(this.$store.state.sev.souce)) this.getAddressList()
  },
  computed: {
    hasHead() {
      // souce:1->APP,2->服务号,3->小程序,4->商城H5,5->评价页面,6->收费标准
      const souce = this.$store.state.sev.souce
      return souce && [1, 4, 6].includes(souce)
    },
    // 是否需要执行动画(IOS小程序的不需要执行,会出现抖动)
    unSlideFade() {
      return this.$bus.isiOS && this.$store.state.sev.souce === 3
    }
  },
  watch: {
    '$store.state.sev.appH': {
      immediate: true,
      async handler(nVal) {
        if (!this.hasHead) return
        await this.$nextTick()
        // 修改导航栏占位部分的高度
        const navBarBodyElement = document.querySelector('.van-nav-bar__placeholder')
        const appBarHeight =
          Number(navBarBodyElement.style.height.replace('px', '') || 0) + Number(nVal)
        navBarBodyElement.style.height = `${appBarHeight}px`
        // 修改导航栏悬浮部分的内边距
        const navBarElement = document.querySelector('.van-nav-bar--fixed')
        navBarElement.style.paddingTop = nVal + 'px'
      }
    }
  },
  methods: {
    setHeight() {
      const doc = document.documentElement
      doc.style.setProperty('--app-height', `${window.innerHeight}px`)
      const headHeight = this.hasHead ? Number(this.$store.state.sev.appH || 0) + 44 : 0
      doc.style.setProperty('--app-head-height', `${headHeight}px`)
    },
    // 获取地址数据
    async getAddressList() {
      const res = await listReceiverInfo({ apiReject: true })
      if (res.code === 0 && res.data.length) {
        const data = res.data.filter(item => item.isMain)
        // 初始选中默认地址
        if (data.length) {
          const obj = {
            receiverInfoId: data[0].receiverInfoId,
            customerName: data[0].receiverName,
            phone: data[0].receiverPhone,
            province: data[0].receiverProvince,
            city: data[0].receiverCity,
            district: data[0].receiverDistrict,
            addressDetail: data[0].receiverAddress,
            longitude: data[0].receiverLongitude,
            latitude: data[0].receiverLatitude
          }
          this.$store.commit('SET_ADDRESS', obj)
        }
      }
    }
  }
}
</script>

<style lang="less">
@import '../assets/style/base/sev.less';

.base {
  &-layout {
    position: relative;
  }
  &-content {
    position: relative;
    &-margin {
      // 设置内容区域最顶部高度代替margin使用
      &::before {
        display: block;
        content: '';
        width: 100%;
        height: 9px;
        background: #f3f5f5;
      }
    }
  }
}
// 路由过度
.slide-fade {
  &-enter {
    opacity: 0;
    transform: translateX(10px);
  }
  &-leave-to {
    opacity: 0;
    transform: translateX(-10px);
  }
  &-enter-active,
  &-leave-active {
    transition: all 0.2s ease;
  }
}
</style>
